import { isNumber } from '@app/typeGuards'
import { mapAbnormalTypeToIconName } from '@app/entities/monitoringResult'

import type { ResultsDto } from '@app/api/routes/monitoringTasks/dtos'
import type { PreviewPrice } from '@app/types'

export const getPreviewPrice = (result: ResultsDto, key: keyof ResultsDto): PreviewPrice | null => {
  const price = result[key]

  if (!isNumber(price)) return null

  return {
    price,
    iconName: mapAbnormalTypeToIconName(result.abnormalType),
    photos: result.photos.map(photo => photo.photo),
    systemComment: result.systemComment
  }
}
